export const REWARDS_FILTERS = ['All', 'Mortgage', 'Card', 'Earned', 'Spent'] as const
export type RewardsFilter = (typeof REWARDS_FILTERS)[number]

export const TRANSITION_TO_SPLIT_SCREEN_WIDTH = 720
